module.exports = __webpack_public_path__ + "img/1.fbb6bf01.png";